import React, { useEffect, useState } from "react";
import { Box, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import ModalWrapper from "../../../components/forms/ModalWrapper";
import CustomAlert from "@/components/alert/CustomAlert";
import { toast } from "@/components/toastify";
import {
  useFetchSettingsFormQuery,
  useFetchSettingsRowsQuery,
  usePostAddSettingsMutation,
  usePostUpdateSettingsMutation,
  useDeleteSettingsMutation,
  usePostUpdateStatusSettingsMutation,
} from "@/api/services/Settings/business/Business";
import CommonDataTable from "@/components/dataTableComponents/NewDatatable";
import StatusChip from "@/components/table/chip";
import { DeleteIcon, EditIcon, SettingsIcon } from "@/icons";
import InfoIcon from "@mui/icons-material/Info";
import { CardWithActions, StyledButton } from "@/components";

const MarketFacingTitle = () => {
  const name = "Market Facing Title";

  const {
    data: formDetails,
    isLoading,
    isError,
  } = useFetchSettingsFormQuery(name);
  const formData = formDetails?.data || {};

  const { data: rowDetails = [] } = useFetchSettingsRowsQuery(name);
  const rowData = rowDetails?.data || [];
  const [addBand] = usePostAddSettingsMutation();
  const [updateBand] = usePostUpdateSettingsMutation();
  const [deleteBand] = useDeleteSettingsMutation();
  const [updateBandStatus] = usePostUpdateStatusSettingsMutation();

  const [open, setOpen] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [openStatus, setopenStatus] = useState(false);
  const [openDelete, setopenDelete] = useState(false);
  const [deleteValue, setDeleteValue] = useState("");
  const [statusValue, setStatusValue] = useState("");
  const [statusLoading, setStatusLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const statusChange = (row) => {
    setStatusValue(row);
    setopenStatus(true);
  };
  const statusClose = () => {
    setopenStatus(false);
  };
  const deleteClose = () => {
    setopenDelete(false);
  };

  const ActionButtons = ({
    row,
    // onViewClick,
    onApproveClick,
    onRejectClick,
  }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const openAction = Boolean(anchorEl);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };
    return (
      <div>
        <Tooltip title="Settings">
          <IconButton onClick={handleClick} size="small">
            <SettingsIcon />
          </IconButton>
        </Tooltip>

        <Menu anchorEl={anchorEl} open={openAction} onClose={handleClose}>
          <MenuItem
            onClick={() => {
              handleOpenModal(row);
              handleClose();
            }}
          >
            <EditIcon fontSize="small" style={{ marginRight: 8 }} />
            Edit
          </MenuItem>
          <MenuItem
            onClick={() => {
              statusChange(row);
              handleClose();
            }}
          >
            <InfoIcon fontSize="small" style={{ marginRight: 8 }} />
            Status
          </MenuItem>
          <MenuItem
            onClick={() => {
              openDeleteModal(row);
              handleClose();
            }}
          >
            <DeleteIcon fontSize="small" style={{ marginRight: 8 }} />
            Delete
          </MenuItem>
        </Menu>
      </div>
    );
  };
  const columns = [
    { field: "name", headerName: "Market Facing Title Name", width: 430 },

    {
      field: "status",
      headerName: "Status",
      width: 400,
      renderCell: (params) => (
        <StatusChip
          label={params.value === "Active" ? "Active" : "Inactive"}
          colorchip={params.value === "Active" ? "#17B26A" : "red"}
          backgroundColor={params.value === "Active" ? "#ECFDF3" : "#FEF3F2"}
          dotColor={params.value === "Active" ? "#17B26A" : "#F04438"}
          borderColor={params.value === "Active" ? "#ABEFC6" : "#FECDCA"}
        />
      ),
    },

    {
      field: "action",
      headerName: "Action",
      width: 400,

      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) {
          setDataTableKey((prevKey) => prevKey + 1);
          return null;
        }
        return (
          <ActionButtons
            row={rowData}
            onApproveClick={handleOpenModal}
            onRejectClick={(rowData) => openDeleteModal(rowData)}
          />
        );
      },
    },
  ];
  const columns1 = [
    { field: "name", headerName: "Market Facing Title Name", flex: 1 },
  ];
  const openDeleteModal = (row) => {
    setDeleteValue(row.value);
    setopenDelete(true);
  };
  const initialValues = {
    name: editRow ? editRow.name : "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(false);
    try {
      if (editRow) {
        const requestEdit = {
          formName: "Market Facing Title",
          formFields: {
            name: values.name,
          },
        };
        const id = editRow.value;
        await updateBand({ formData: requestEdit, id, name }).unwrap();
        toast("success", "Market Facing Title updated successfully");
        setOpen(false);

        // await refetch();
      } else {
        const requestBody = {
          formName: "Market Facing Title",
          formFields: {
            name: values.name,
          },
        };
        await addBand({ formData: requestBody, name }).unwrap();
        toast("success", "Market Facing Title added successfully");
        setOpen(false);

        // await refetch();
      }
      // refetch();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  const handleDeleteSubmit = async () => {
    setDeleteLoading(true);
    try {
      await deleteBand({ id: deleteValue, name }).unwrap();
      toast("success", "Market Facing Title deleted successfully");
      deleteClose(false);
      setDeleteLoading(false);
    } catch (error) {
      console.error("Error deleting band:", error);
      setDeleteLoading(false);
    }
  };
  const handleStatusSubmit = async () => {
    setStatusLoading(true);
    try {
      const newStatus = statusValue.status === "Active" ? "Inactive" : "Active";
      await updateBandStatus({
        id: statusValue.value,
        status: newStatus,
        name,
      }).unwrap();
      toast("success", "Market Facing Title status updated successfully");
      statusClose(false);
      setStatusLoading(false);
    } catch (error) {
      console.error("Error updating status:", error);
      setStatusLoading(false);
    }
  };
  const handleOpenModal = (row = null) => {
    setEditRow(row);
    setOpen(true);
  };

  const headers = ["Market Facing Title Name"];

  return (
    <CardWithActions
      headerTitle={"Market Facing Title"}
      headerActions={[
        <StyledButton
          size="medium"
          label="+ Add Market Facing Title"
          onClick={() => handleOpenModal()}
        />,
      ]}
    >
      <Box>
        <ModalWrapper
          open={open}
          handleClose={() => setOpen(false)}
          initialValues={editRow ? initialValues : {}}
          formData={formData}
          onSubmit={handleSubmit}
          label={
            editRow ? "Edit Market Facing Title" : "Add Market Facing Title"
          }
        />
        <CustomAlert
          open={openStatus}
          title="Change Status"
          message="Are you sure you want to Change the Status?"
          onCancel={statusClose}
          onSubmit={handleStatusSubmit}
          cancelText="Close"
          submitText="Save"
          isSubmitting={statusLoading}
        />
        <CustomAlert
          open={openDelete}
          title="Delete Market Facing Title"
          message="Are you sure you want to Delete this Record?"
          onCancel={deleteClose}
          onSubmit={handleDeleteSubmit}
          cancelText="Close"
          submitText="Delete"
          isSubmitting={deleteLoading}
        />

        {/* <SettingCard
        columns={columns}
        headers={headers}
        title="Market Facing Title"
        onEditClick={handleOpenModal}
        onStatusChange={statusChange}
        onDeleteClick={openDeleteModal}
        onAddButtonClick={() => handleOpenModal()}
        rows={rowData}
      /> */}
        <CommonDataTable
          columns={columns}
          rows={rowData}
          searchBar={true}
          search={true}
        />
      </Box>
    </CardWithActions>
  );
};

export default MarketFacingTitle;
